<template>
  <div class="nv-shell">
    <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>

    <!-- begin:: Üst Bölge (Header + Sayfa Başlığı) -->
    <section class="nv-top">
      <KTHeader></KTHeader>

      <div class="nv-container nv-hero">
        <div class="nv-hero__text">
          <span class="nv-hero__eyebrow">e-Dönüşüm Aktivasyon</span>
          <h1 class="nv-hero__title">{{ pageMeta.title }}</h1>
          <p v-if="pageMeta.subtitle" class="nv-hero__subtitle">{{ pageMeta.subtitle }}</p>
        </div>

        <ol class="nv-journey" aria-label="İşlem adımları">
          <li
              v-for="(step, index) in journeySteps"
              :key="index"
              class="nv-journey__item"
              :class="{
                'is-active': pageMeta.journey === index + 1,
                'is-complete': pageMeta.journey > index + 1
              }"
          >
            <span class="nv-journey__dot">
              <v-icon v-if="pageMeta.journey > index + 1" x-small>mdi-check</v-icon>
              <template v-else>{{ index + 1 }}</template>
            </span>
            <span class="nv-journey__label">{{ step }}</span>
          </li>
        </ol>
      </div>
    </section>
    <!-- end:: Üst Bölge -->

    <!-- begin:: İçerik -->
    <main id="kt_content" class="nv-main">
      <div class="nv-container">
        <transition name="fade-in-up" mode="out-in">
          <router-view/>
        </transition>
      </div>
    </main>
    <!-- end:: İçerik -->

    <KTFooter></KTFooter>
    <KTScrollTop></KTScrollTop>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import KTHeader from "@/view/layout/header/Header.vue";
import KTFooter from "@/view/layout/footer/Footer.vue";
import HtmlClass from "@/core/services/htmlclass.service";
import KTScrollTop from "@/view/layout/extras/ScrollTop";
import Loader from "@/view/content/Loader.vue";
import {ADD_BODY_CLASSNAME, REMOVE_BODY_CLASSNAME} from "@/core/services/store/htmlclass.module.js";

export default {
  name: "Layout",
  components: {
    KTHeader,
    KTFooter,
    KTScrollTop,
    Loader
  },
  data() {
    return {
      journeySteps: ["Bağlantı", "Giriş", "Başvuru & Yönetim"]
    };
  },
  beforeMount() {
    // show page loading
    this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");

    // initialize html element classes
    HtmlClass.init(this.layoutConfig());
  },
  mounted() {
    // Simulate the delay page loading
    setTimeout(() => {
      // Remove page loader after some time
      this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
    }, 2000);
  },
  computed: {
    ...mapGetters(["layoutConfig"]),

    /**
     * Aktif sayfanın başlık / açıklama bilgileri (router meta)
     */
    pageMeta() {
      return Object.assign({title: "", subtitle: "", journey: 0}, this.$route.meta);
    },

    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },

    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    }
  }
};
</script>
